import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// import { Button, message } from "ant-design-vue";
import "./core/use";
import { getProjectName } from "@/api/api";
Vue.config.productionTip = false;

// getProjectName()
//   .then(c => {
//     if (c.data.code !== 200) {
//       return;
//     }
//     document.title = c.data.data;
//     store.commit("setProjectName", c.data.data);
//   })
//   .catch(e => {
//     console.log(e);
//   });

// Vue.use(Button);

// Vue.prototype.$message = message;
Vue.prototype.$sensortypeRound = colorIntensity.sensortypeRound;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
